import { Grid as MaterialGrid, useTheme } from "@material-ui/core";

export const Grid = ({ children, ...props }) => {
  const theme = useTheme();
  if (props.container && props.spacing) {
    return (
      <div style={{ padding: theme.spacing(props.spacing) / 2, width: "100%" }}>
        <MaterialGrid {...props}>{children}</MaterialGrid>
      </div>
    );
  }
  return <MaterialGrid {...props}>{children}</MaterialGrid>;
};
